import {PaginatedResponse} from "@/models/PaginatedResponse";

export class Paginated<T> {
    total: number = 0;
    items: T[] = []

    static map(data: PaginatedResponse<any>, generic: any) {
        const item = new Paginated<any>();
        item.total = data.totalElements;
        item.items = data.content.map(generic.map);
        return item;
    }
}
